<script setup>
	import PlantLogo from './PlantLogo.vue';
	const route = useRoute();

	const isGardens = computed(() => String(route.name || '').includes('profiles-id-gardens'));
	const isMenuOpen = useState('drawer', () => false);
</script>

<template>
	<header class="uo-topbar sticky top-0 z-40" :class="{'landscape:static': isGardens}">
		<div class="uo-topbar-inner">
			<button class="uo-shell-icon lg:hidden" form="toggle-menu" aria-label="Навигация" aria-controls="nav" :aria-expanded="isMenuOpen">
				<svg-icon name="menu" width="32" height="32"></svg-icon>
				<svg-icon class="hidden" name="close" width="32" height="32"></svg-icon>
			</button>
			<nuxt-link to="/" class="uo-topbar-brand">
				<PlantLogo />
				<span class="uo-topbar-brand-name">Умный огород</span>
			</nuxt-link>
			<div class="uo-topbar-actions">
				<slot name="end">
					<nuxt-link to="/auth/signin" class="uo-shell-signin">
						<span><svg-icon class="align-middle" name="account-circle-outline" width="20" height="20"/></span> <span class="align-middle">Войти</span>
					</nuxt-link>
				</slot>
			</div>
		</div>
	</header>
</template>
